import React from 'react';
import styled from 'styled-components';
import { fontFamily, fontSize } from '../../../../../../constants/text';
import { colors } from '../../../../../../constants/colors';
import { useCopayCoinsuranceStepCopy } from '../../../../../Account/Profile/Insurance/util/insuranceDetails';

const Root = styled.div.withConfig({ componentId: 'sc-1ta4fc7-0' })`
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  letter-spacing: 0.25px;
  line-height: 21px;
`;

const PurpleBar = styled.div.withConfig({ componentId: 'sc-1ta4fc7-1' })`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 56px;
  width: 100%;
  background: linear-gradient(90deg, #9a40f5 0%, #bd3ceb 100%);
  border-radius: 8px 8px 0 0;
  margin-bottom: 15px;
  font-family: ${fontFamily.book};
  color: ${colors.theWhiteAlbum};
  font-weight: 500;
`;

const Network = styled.div.withConfig({ componentId: 'sc-1ta4fc7-2' })`
  font-size: ${fontSize.medium};
  letter-spacing: 0.33px;
`;

const YouOwe = styled.div.withConfig({ componentId: 'sc-1ta4fc7-3' })`
  font-size: ${fontSize.small};
  letter-spacing: 0.22px;
`;

const HeaderContainer = styled.div.withConfig({ componentId: 'sc-1ta4fc7-4' })`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 85%;
  margin: 0 auto;
`;

const Row = styled.div.withConfig({ componentId: 'sc-1ta4fc7-5' })`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 15px;
  padding: 10px 25px;
  line-height: 1.8em;
  width: 80%;
  margin: 0 auto;
  color: ${colors.blueMonday};
  font-family: ${fontFamily.book};
  opacity: ${(props) =>
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'sc' does not exist on type 'ThemedStyled... Remove this comment to see the full error message
    props.sc && props.sc.isHighlightedRow ? '1' : '0.56'};
  background-color: ${(props) =>
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'sc' does not exist on type 'ThemedStyled... Remove this comment to see the full error message
    props.sc && props.sc.isHighlightedRow ? colors.grayDim : colors.theWhiteAlbum};
  border-radius: 4px;

  :last-of-type {
    padding-bottom: 20px;
  }
`;

const Footer = styled.div.withConfig({ componentId: 'sc-1ta4fc7-6' })`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  text-align: center;
  width: 100%;
  box-shadow: inset 0 1px 0 0 rgba(223, 225, 227, 0.63);
  background-color: ${colors.whiteGrey};
`;

const Icon = styled.img.withConfig({ componentId: 'sc-1ta4fc7-7' })`
  width: 30px;
  padding: 20px;
`;

const StepContainer = styled.div.withConfig({ componentId: 'sc-1ta4fc7-8' })`
  margin-top: 0;
`;

const Title = styled.div.withConfig({ componentId: 'sc-1ta4fc7-9' })`
  width: 60%;
`;

const Tip = styled.div.withConfig({ componentId: 'sc-1ta4fc7-10' })`
  font-family: ${fontFamily.book};
  font-size: ${fontSize.small};
  letter-spacing: 0.2px;
  line-height: 20px;
  color: ${colors.blueMonday};
  text-align: left;
  width: 80%;
`;

type Props = {
  tile?: any;
  insuranceDetails?: any;
  providerType?: string;
};

const CopayCoinsuranceDetails = (props: Props) => {
  const { tile, insuranceDetails, providerType } = props;

  const { modal: modalStepCopy } = useCopayCoinsuranceStepCopy(
    insuranceDetails,
    providerType,
    tile.isInNetwork
  );

  if (!modalStepCopy) return null;

  return (
    <Root>
      <PurpleBar>
        <HeaderContainer>
          <Network>{tile.title}</Network>

          <YouOwe>YOU'LL OWE</YouOwe>
        </HeaderContainer>
      </PurpleBar>

      <StepContainer>
        {modalStepCopy.map((step: any, i: any) => (
          <Row
            data-testid={`copay-details-row-${i + 1}`}
            key={`${step.title}${step.value}`}
            // @ts-expect-error ts-migrate(2769) FIXME: Property 'sc' does not exist on type 'IntrinsicAtt... Remove this comment to see the full error message
            sc={{ isHighlightedRow: step.isCurrentStep }}
          >
            <Title>{step.title}</Title>

            <div>{step.value}</div>
          </Row>
        ))}
      </StepContainer>

      <Footer>
        <Icon src={tile.icon} />

        <Tip>{tile.subtext}</Tip>
      </Footer>
    </Root>
  );
};

export default CopayCoinsuranceDetails;
